<template>
  <div>
    <b-row align-h="center">
      <b-card class="mb-3" style="width: 90%">
        <b-container v-if="submital">
          <b-row align-v="center">
            <b-col cols="7">
              <b-row class="text-muted d-flex align-items-center">
                <font-awesome-icon v-if="submitalLocked(submital)" :icon="['fas', 'lock-alt']" size="sm" class="mr-1" fixed-width />
                <span class="mr-1">{{ submital.submital_no }} - </span>
                <span>{{ submitalType(submital) }}</span>
              </b-row>
            </b-col>
            <b-col cols="5">
              <b-row align-h="end" align-v="center">
                <span class="pl-2 text-muted">{{ submital.progress }}%</span>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="pb-3 border-bottom">
            <span v-if="submital.title">{{ submital.title }}</span>
            <span v-else class="text-muted font-italic">(Sin Nombre)</span>
          </b-row>
          <b-row class="my-3 pb-3 border-bottom">
            <b-col>
              <b-row align-h="center" align-v="center">
                <span class="fs-13" style="padding-top: 2px">Cant.</span>
                <span class="pl-1">{{ submital.quantity }}</span>
              </b-row>
            </b-col>
            <b-col>
              <b-row align-h="center" align-v="center" style="padding-top: 2px">
                <span class="fs-13 mr-1" style="padding-top: 2px">Actuador.</span>
                <span v-if="submital.configurable && submital.configurable.access_control_type">{{ submital.configurable.access_control_type.name }}</span>
                <span v-else>-</span>
              </b-row>
            </b-col>
            <b-col>
              <b-row align-h="center" align-v="center" style="padding-top: 2px">
                <span class="fs-13 mr-1" style="padding-top: 2px">Submital.</span>
                <p class="pb-0 mb-0" v-if="submital.related_configurable">
                  {{ submital.related_configurable.submital_no || submital.related_configurable.acceso_id }}
                </p>
                <span v-else>-</span>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="isAuthorized" align-h="between" class="mt-3">
            <Button size="sm"  @click="$emit('copy-submital', submital, true)">
              <font-awesome-icon :icon="['far', 'copy']" fixed-width />
              <span class="pl-1">Copiar</span>
            </Button>
            <Button size="sm" variant="blue" @click="goToSubmital(submital)">
              Config
            </Button>
          </b-row>
        </b-container>
      </b-card>
    </b-row>
  </div>
</template>

<script>
import Button from '../../shared/Button'

export default {
  name: 'ProjectShowSubmitalCard',
  components: { Button },
  props: {
    submital: {
      type: Object
    },
    isAuthorized: {
      type: Boolean
    }
  },
  methods: {
    goToSubmital (submital) {
      this.$router.push(`/app/prod/submitals/${submital.id}`)
    },
    submitalLocked (submital) {
      return submital.locked_at != null
    },
    submitalType (submital) {
      const submitalMap = {
        'Configurator::ControlAcceso': 'Control de acceso',
        'Configurator::AndenBorde': 'Anden de borde',
        'Configurator::PuertaAutomatica': 'Puerta automática',
        'Configurator::Cortina': 'Cortina',
        'Configurator::Generico': 'Genérico'
      }
      return submitalMap[submital.configurable_type] || 'submital'
    }
  }
}
</script>
